import React, { FunctionComponent } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { RadioButtonType } from '@lyrahealth-inc/shared-app-logic/src/models/formMetadata/FormMetadata'

import { RadioGroup } from '../../atoms/formElements/RadioButtons'
import { InlineInfoBanner } from '../../molecules/inlineInfoBanner/InlineInfoBanner'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export enum ScopeSelection {
  SelectedSession = 'selectedSession',
  AllSessions = 'allSessions',
}

const ModalBody = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  gap: theme.spacing['16px'],
  width: '100%',
}))

export type ProviderCalendarEditSessionModalityScopeContentProps = {
  upcomingAppointmentsCount: number
  scopeSelection: ScopeSelection
  onScopeSelectionChange: (scopeSelection: ScopeSelection) => void
}

export const ProviderCalendarEditSessionModalityScopeContent: FunctionComponent<
  ProviderCalendarEditSessionModalityScopeContentProps
> = ({ upcomingAppointmentsCount, scopeSelection, onScopeSelectionChange }) => {
  const { colors } = useTheme() as ThemeType
  const { formatMessage } = useIntl()

  const emailNotificationText = (
    <FormattedMessage
      defaultMessage="If it's less than 72 hours before the session time we'll email this client notifying them of the change."
      description='Info banner shown when editing modality'
    />
  )

  return (
    <ModalBody>
      <InlineInfoBanner
        testId={tID('ProviderCalendarEditSessionModalityScopeContent-banner')}
        text={emailNotificationText}
        backgroundColor={colors.backgroundSection}
        textColor={colors.textPrimary}
        iconColor={colors.iconDefault}
        marginBottom='0px'
      />
      <RadioGroup
        selectedValue={scopeSelection}
        onChange={onScopeSelectionChange}
        buttonType={RadioButtonType.DESCRIPTION_NO_OUTLINE}
        buttons={[
          {
            label: formatMessage({
              defaultMessage: 'This session only',
              description: 'Scope option for single session modality update',
            }),
            value: 'selectedSession',
          },
          {
            label: formatMessage(
              {
                defaultMessage: 'All upcoming sessions ({count})',
                description: 'Scope option to update all upcoming sessions',
              },
              { count: upcomingAppointmentsCount },
            ),
            value: 'allSessions',
          },
        ]}
      />
    </ModalBody>
  )
}
